import type { Burndown, ProjectSummary, Velocity } from '@tasks/contracts';

import { apiRequest } from './client';

export function getSummary(projectKey: string, days: number, signal?: AbortSignal): Promise<ProjectSummary> {
  return apiRequest<ProjectSummary>(`/projects/${encodeURIComponent(projectKey)}/reports/summary`, {
    query: { days },
    signal,
  });
}

export function getBurndown(projectKey: string, sprintId: string, signal?: AbortSignal): Promise<Burndown> {
  return apiRequest<Burndown>(`/projects/${encodeURIComponent(projectKey)}/reports/burndown`, {
    query: { sprintId },
    signal,
  });
}

export function getVelocity(projectKey: string, signal?: AbortSignal): Promise<Velocity> {
  return apiRequest<Velocity>(`/projects/${encodeURIComponent(projectKey)}/reports/velocity`, { signal });
}
